module.exports = __webpack_public_path__ + "static/media/tab_2.a36ec831.png";